import React, { Fragment } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import CreateEnvWizard from './new/CreateEnvWizard';
import DevEnvDetail from './detail/DevEnvDetail';

const DevEnvs = () => {
  return (
    <Fragment>
      <Routes>
        <Route index element={<DevEnvDetail />} />
        <Route path="env/:env_id" element={<DevEnvDetail />} />
        <Route path="new" element={<CreateEnvWizard />} />
      </Routes>
      <Outlet />
    </Fragment>
  );
};

export default DevEnvs;
